import React from 'react'
import Project from './Components/Project'
function Index() {
  return (
    <div className='w-full mt-40 mb-20 flex flex-col center'>
      <div className='w-[70%] flex flex-col'>
        <Project />
        <Project />
      </div>
    </div>

  )
}

export default Index